module.exports = __webpack_public_path__ + "img/help.b054a63b.svg";